import React from 'react';
import { PageStyle } from '../Utils/generalStyles';

// Components
import ManageNftsSection from '../Components/ManageNfts';
import FooterSection from '../Components/Footer';

const ManageMembers = () => (
  <PageStyle>
    <ManageNftsSection />
    <FooterSection />
  </PageStyle>
);

export default ManageMembers;
